const findSection = n => n?.closest?.('[id^="shopify-section-"]') || n?.closest?.('section') || document;
const initOne = (el) => {
    if (!el || el.__flkty) return;
    if (typeof Flickity === 'undefined') return console.warn('Flickity missing');

    const section = findSection(el);
    const prev = section.querySelector('.js-media-prev');
    const next = section.querySelector('.js-media-next');

    const flkty = new Flickity(el, {
        cellAlign: 'left', contain: true, wrapAround: false,
        prevNextButtons: false, pageDots: false, draggable: true, watchCSS: false
    });
    el.__flkty = flkty;

    const setBtn = (b, on) => b && (b.classList.toggle('is-disabled', !on), b.disabled = !on, b.tabIndex = on ? 0 : -1, b.setAttribute('aria-disabled', String(!on)));
    const upd = () => {
        const total = flkty?.cells?.length || 0;
        if (total <= 1) { setBtn(prev, false); setBtn(next, false); return; }
        const i = typeof flkty.selectedIndex === 'number' ? flkty.selectedIndex : 0;
        setBtn(prev, i > 0); setBtn(next, i < total - 1);
    };

    prev && prev.addEventListener('click', () => flkty.previous());
    next && next.addEventListener('click', () => flkty.next());
    ['ready', 'change', 'select', 'settle', 'resize', 'reload'].forEach(e => flkty.on(e, upd));
    upd(); queueMicrotask(upd); requestAnimationFrame(upd);

    const ro = typeof ResizeObserver !== 'undefined' ? new ResizeObserver(() => { flkty.resize(); flkty.reposition && flkty.reposition(); upd(); }) : null;
    ro && ro.observe(el);
    const onW = () => { flkty.resize(); flkty.reposition && flkty.reposition(); upd(); };
    window.addEventListener('resize', onW, { passive: true });

    const cleanup = () => {
        ro && ro.disconnect();
        window.removeEventListener('resize', onW);
        ['ready', 'change', 'select', 'settle', 'resize', 'reload'].forEach(e => flkty.off && flkty.off(e, upd));
        try { flkty.destroy(); } catch (e) { }
        el.__flkty = null;
    };

    (section.__carouselCleanups = section.__carouselCleanups || []).push(cleanup);
    el.__cleanup = cleanup;
};

const initAll = () => document.querySelectorAll('.js-gift-main-carousel').forEach(initOne);

if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();

document.addEventListener('shopify:section:load', e => e?.target?.querySelectorAll && e.target.querySelectorAll('.js-gift-main-carousel').forEach(initOne));
document.addEventListener('shopify:section:unload', e => {
    const t = e?.target; if (!t) return;
    (t.__carouselCleanups || []).forEach(fn => { try { fn(); } catch (_) { } });
    t.__carouselCleanups = [];
    t.querySelectorAll && t.querySelectorAll('.js-gift-main-carousel').forEach(el => el.__cleanup && el.__cleanup());
});